import React from 'react';
import { InfoIcon } from 'tuui';
import { INDICATION_TYPES, IndicationContent } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './additionalInfoIndication.module.scss';

export const AdditionalInfoIndication = () => {
    return (
        <IndicationContent type={INDICATION_TYPES.NONE} containerClassName={styles['info-indication']}>
            <div className={styles['indication-children']}>
                <InfoIcon className={styles['info-icon']} fontSize="small" />
                <FormattedMessage
                    id="pixel.tester.find.additional.info"
                    defaultMessage="<i>Find additional info in the <b><a>Dev Center</a></b></i>"
                />
            </div>
        </IndicationContent>
    );
};
